import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { axios } from 'utils/axios';
import { LikedIds } from '@novaheal/types';

export const fetchLikes = async (): Promise<LikedIds> => {
  const { data: likes } = await axios.get('/user/likes');
  return likes;
};

export const useLikes = (enabled = true): UseQueryResult<LikedIds> => {
  return useQuery({
    queryKey: ['likes'],
    queryFn: fetchLikes,
    // Without this, staleTime defaults to 0 — every LikeButton mount (one
    // per ArticleEntry/MedicationCard/SearchResult) treats the cached list
    // as stale and re-fetches in the background, so scrolling through any
    // content list re-triggers GET /user/likes on every newly-rendered
    // card. useAddLike/useRemoveLike already patch this cache directly on
    // success (see updateLike.ts/removeLike.ts), so a like/unlike still
    // reflects immediately everywhere — staleTime only suppresses
    // redundant background refetches on mount.
    staleTime: 5 * 60 * 1000,
    // Lets callers that already know the answer (e.g. the Favorites list,
    // where every rendered item is by definition liked) skip this fetch
    // entirely instead of asking the server something they already know.
    enabled,
  });
};
